require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-edmond-lau.json") })
        }
      }, "path---blog-author-edmond-lau");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-edmond-lau!./.cache/json/blog-author-edmond-lau.json
// module id = 634
// module chunks = 231608221292675